<template>
    <div class="lang">
        <van-field
            v-model="assetNum"
            required
            label="资产编号"
            label-width="110"
            right-icon="scan"
            placeholder="扫码或手动输入资产编号"
            @click-right-icon="onScan"
            @blur="inputFinish"
        />
    </div>
</template>
<script>
import { Field, Icon, Toast } from 'vant';
export default {
    name:"ScanQR",
    components:{
        [Field.name]: Field,
        [Icon.name]: Icon
    },
    props: {
        size: String,
        value: String
    },
    data(){
        return{
            assetNum: this.value
        }
    },
    methods:{
        onScan() {
            this.$wx.scanQRCode({
                desc: "资产二维码",
                needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
                scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success:(res) => {
                    this.$emit('scan', res.resultStr);
                },
                error: (res) => {
                    if (res.errMsg.indexOf("function_not_exist") > 0) {
                        Toast('版本过低请升级')
                    } else {
                        Toast('调用扫码失败');
                    }
                }
            });
        },
        inputFinish() {
            this.$emit('input', this.assetNum)
        }
    },
    watch: {
        value() {
            this.assetNum = this.value
        }
    },
    created() {

    }
}
</script>
<style lang="less" scoped>

</style>
